(function () {
  const TIERS = [
    { min: 1, label: "1 item",  pct: 0  },
    { min: 2, label: "2 items", pct: 5  },
    { min: 3, label: "3 items", pct: 10 },
    { min: 4, label: "4 items", pct: 25 },
    { min: 5, label: "5+ items", pct: 40 },
  ];
  const PROGRESS_TAG = "progress";
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const join = (p) => (ROOT.replace(/\/$/, "") + "/" + p.replace(/^\//, ""));

  const POPUP_HTML = `
    <div id="bundle-popup-overlay">
      <div id="bundle-popup">
        <div id="bundle-popup-header">
          <h3>Added to cart</h3>
          <button id="bundle-popup-close" aria-label="Close">&times;</button>
        </div>
        <div id="bundle-popup-added-row">
          <img id="bundle-popup-img" src="" alt="" />
          <div id="bundle-popup-info">
            <span id="bundle-popup-title"></span>
          </div>
          <a id="bundle-popup-cart-link" href="${join('cart')}">Go to cart</a>
        </div>
        <span id="bundle-popup-banner-text"></span>
        <div id="bundle-popup-progress-card">
          <p id="bundle-popup-subtitle">Add more eligible items to your cart to unlock discounts—plus potential savings on shipping!</p>
          <div id="bundle-popup-bar">
            <div id="bundle-popup-bar-fill"></div>
            <div id="bundle-popup-bar-ticks">
              <div class="bp-tick"></div>
              <div class="bp-tick"></div>
              <div class="bp-tick"></div>
              <div class="bp-tick"></div>
              <div class="bp-tick"></div>
            </div>
          </div>
          <div id="bundle-popup-steps">
            <div class="bp-step"><span>1 item</span><strong>0% off</strong></div>
            <div class="bp-step"><span>2 items</span><strong>5% off</strong></div>
            <div class="bp-step"><span>3 items</span><strong>10% off</strong></div>
            <div class="bp-step"><span>4 items</span><strong>25% off</strong></div>
            <div class="bp-step"><span>5+ items</span><strong>40% off</strong></div>
          </div>
        </div>
      </div>
    </div>`;

  function injectPopup() {
    if (document.getElementById("bundle-popup-overlay")) return;
    const wrap = document.createElement("div");
    wrap.innerHTML = POPUP_HTML.trim();
    document.body.appendChild(wrap.firstChild);
    document.getElementById("bundle-popup-close").addEventListener("click", closePopup);
  }

  function getTierIndex(count) {
    if (count >= 5) return 4;
    return Math.max(0, count - 1);
  }
  function getNextTier(count) {
    const idx = getTierIndex(count);
    return idx < TIERS.length - 1 ? TIERS[idx + 1] : null;
  }
  function updateProgressUI(count) {
    const tierIdx = getTierIndex(count);
    const pct = (tierIdx / (TIERS.length - 1)) * 100;
    const fill = document.getElementById("bundle-popup-bar-fill");
    if (fill) fill.style.width = pct + "%";
    document.querySelectorAll(".bp-step").forEach((step, i) => {
      step.classList.toggle("active", i <= tierIdx);
    });
  }

  function showPopup(product, progressCount) {
    if (window.innerWidth > 768) return;
    injectPopup();
    const overlay = document.getElementById("bundle-popup-overlay");
    const img = document.getElementById("bundle-popup-img");
    const title = document.getElementById("bundle-popup-title");
    const bannerText = document.getElementById("bundle-popup-banner-text");

    let imgSrc = "";
    if (product.featured_image) {
      imgSrc = typeof product.featured_image === "string" ? product.featured_image : product.featured_image.url;
    } else if (product.image) imgSrc = product.image;
    else if (product.images && product.images[0]) imgSrc = product.images[0];
    if (imgSrc && imgSrc.startsWith("//")) imgSrc = "https:" + imgSrc;
    img.src = imgSrc;
    img.alt = product.title || product.product_title || "Product image";
    title.textContent = product.title || product.product_title || "";

    const nextTier = getNextTier(progressCount);
    if (nextTier) {
      const diff = nextTier.min - progressCount;
      bannerText.textContent =
        diff === 1
          ? `1 item away from ${nextTier.pct}% off bundle discount`
          : `${diff} items away from ${nextTier.pct}% off bundle discount`;
    } else {
      bannerText.textContent = `You unlocked 40% off bundle discount!`;
    }

    updateProgressUI(progressCount);
    // Force reflow before adding is-open so transform animates
    void overlay.offsetWidth;
    overlay.classList.add("is-open");
  }

  function closePopup() {
    const overlay = document.getElementById("bundle-popup-overlay");
    if (overlay) overlay.classList.remove("is-open");
  }

  function normalizeTags(t) {
    if (!t) return [];
    if (Array.isArray(t)) return t.map(x => String(x).toLowerCase());
    return String(t).split(",").map(x => x.trim().toLowerCase());
  }

  async function fetchProductByHandle(handle) {
    try {
      const r = await fetch(join(`products/${handle}.js`), { credentials: "same-origin" });
      if (!r.ok) return null;
      return await r.json();
    } catch (e) { return null; }
  }

  async function getProgressItemCount() {
    try {
      const res = await fetch(join("cart.js"), { credentials: "same-origin" });
      const cart = await res.json();
      const handles = [...new Set(cart.items.map(i => i.handle))];
      const products = await Promise.all(handles.map(h => fetchProductByHandle(h)));
      const tagMap = {};
      products.forEach(p => {
        if (p && p.handle) tagMap[p.handle] = normalizeTags(p.tags).includes(PROGRESS_TAG);
      });
      let count = 0;
      cart.items.forEach(i => { if (tagMap[i.handle]) count += i.quantity; });
      return count;
    } catch (e) { return 0; }
  }

  async function handleAddedProduct(data) {
    if (!data || !data.handle) return;
    let tags = normalizeTags(data.tags);
    let productForPopup = data;
    if (!tags.includes(PROGRESS_TAG)) {
      const fullProduct = await fetchProductByHandle(data.handle);
      if (!fullProduct) return;
      tags = normalizeTags(fullProduct.tags);
      if (!tags.includes(PROGRESS_TAG)) return;
      productForPopup = Object.assign({}, fullProduct, data);
    }
    const count = await getProgressItemCount();
    showPopup(productForPopup, count);
  }

  // Idempotency guard — never install the hook twice
  // (protects against theme editor reloads, accidental script duplication)
  if (window.__bundlePopupFetchHookInstalled) return;
  window.__bundlePopupFetchHookInstalled = true;

  // Fetch hook — Stiletto theme uses fetch() for /cart/add.js (confirmed
  // in theme.js:4540). XHR hook removed as dead code — theme never uses
  // XMLHttpRequest for cart operations.
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const response = originalFetch.apply(this, args);

    // Always return the original response untouched. The popup logic
    // runs in a separate microtask via .then so it cannot affect the
    // caller's await chain even on errors.
    Promise.resolve(response).then(res => {
      try {
        if (!res || typeof res.clone !== "function") return;
        const url = typeof args[0] === "string"
          ? args[0]
          : (args[0] && args[0].url) || "";
        if (url.indexOf("/cart/add") === -1) return;

        res.clone().json()
          .then(data => {
            try {
              if (data && Array.isArray(data.items)) {
                data.items.forEach(it => handleAddedProduct(it));
              } else {
                handleAddedProduct(data);
              }
            } catch (e) { /* swallow — popup is non-critical */ }
          })
          .catch(() => { /* not JSON or already consumed — ignore */ });
      } catch (e) { /* swallow */ }
    }).catch(() => { /* original fetch rejected — not our problem */ });

    return response;
  };
})();